import React from "react";
import StandDetailProductsTabView from "./view";
import { Stand } from "../../../../data/interfaces";

interface Props {
  stand: Stand;
}

const StandDetailProductsTabContainer = ({ ...restProps }: Props) => {
  return <StandDetailProductsTabView {...restProps} />;
};

export default StandDetailProductsTabContainer;
